import React from 'react'
import styled from 'styled-components'

interface ProgressProps {
  percentage: number
  backgroundColor?: string
  color: string
  // Bar thickness in px.
  height?: number
  className?: string
}

export const ProgressBar: React.FC<ProgressProps> = ({
  percentage,
  backgroundColor,
  color,
  height = 12,
  className,
}) => {
  return (
    <ProgressContainer
      color={backgroundColor}
      $height={height}
      className={className}
    >
      <Progress percentage={percentage} color={color} />
    </ProgressContainer>
  )
}

const Progress = styled.div<{
  percentage: number
  color: string
}>`
  width: ${({ percentage }) => percentage}%;
  height: 100%;
  background-color: ${({ color }) => color};
  border-radius: 50px;
`

const ProgressContainer = styled.div<{
  color?: string
  $height: number
}>`
  position: relative;
  width: 100%;
  height: ${({ $height }) => $height}px;
  background-color: ${({ color, theme }) => color ?? theme.colors.lightest};
  border-radius: 50px;
  overflow: hidden;
`
